import { render } from "./TariffsIndividualItem.vue?vue&type=template&id=5d4c987f&scoped=true&ts=true"
import script from "./TariffsIndividualItem.vue?vue&type=script&lang=ts"
export * from "./TariffsIndividualItem.vue?vue&type=script&lang=ts"

import "./TariffsIndividualItem.vue?vue&type=style&index=0&id=5d4c987f&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4c987f"]])

export default __exports__